import * as Sentry from "@sentry/react";

import config from "./src/config";

Sentry.init({
  dsn: config.SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: parseFloat(config.SENTRY_TRACES_SAMPLE_RATE), // Capture X% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [],
  // Session Replay
  replaysSessionSampleRate: parseFloat(config.SENTRY_REPLAY_SESSION_SAMPLE_RATE), // You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: parseFloat(config.SENTRY_REPLAY_ONERROR_SAMPLE_RATE), // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
